module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slideShowContainer",
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.keyboardLeftClick($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        return _vm.keyboardRightClick($event)
      }]
    }
  }, [_c('div', {
    staticClass: "header pointer"
  }, [_c('span', {
    staticClass: "close-btn pointer",
    on: {
      "click": this.$props.toggleSlideShow
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")]), _c('label', {
    staticClass: "pl-1"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white",
      "width": "33.33%"
    }
  }, [_vm._v(_vm._s(_vm.currentIndex + 1 + " / " + this.$props.imageArray.length))]), _vm._v(" "), _c('div', {
    staticClass: "like-share-container"
  }, [_c('div', {
    staticClass: "icon-container pointer",
    on: {
      "click": _vm.addLike
    }
  }, [_c('i', {
    staticClass: "material-icons",
    style: (_vm.getImageDescription.isLiked ? 'color:#ff0000' : '')
  }, [_vm._v(_vm._s(_vm.getImageDescription.isLiked ? "favorite" : "favorite_outline"))])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container ml-2 pointer",
    on: {
      "click": function($event) {
        return _vm.share(
          _vm.getImageDescription.photoId,
          _vm.getImageDescription.caption === '' ?
          'n' :
          _vm.getImageDescription.caption
        )
      }
    }
  }, [_c('img', {
    staticClass: "share-icon",
    attrs: {
      "src": "/static/img/ic-reply.svg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-container"
  }, [_c('v-carousel', {
    attrs: {
      "hide-delimiters": "",
      "height": _vm.screenW >= 800 ? 'auto' : 400,
      "cycle": false
    },
    model: {
      value: (_vm.currentIndex),
      callback: function($$v) {
        _vm.currentIndex = $$v
      },
      expression: "currentIndex"
    }
  }, _vm._l((this.$props.imageArray), function(item, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "lazy": true
      }
    }, [_c('div', [_c('img', {
      staticClass: "slide-image",
      attrs: {
        "src": _vm.listviewImage(("" + (item.photoId)), item),
        "alt": "image",
        "width": "auto"
      }
    })])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "photo-description"
  }, [_c('div', {
    staticClass: "photographer-profile-det-container"
  }, [_c('div', {
    class: _vm.getImageDescription.uploader !== 'admin' ?
      'pointer photographer-profile-user' :
      'photographer-profile',
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.getImageDescription.uploader !== 'admin') ? _c('img', {
    attrs: {
      "src": _vm.getImageDescription.mediaSourceInformation.photoGrapherPic,
      "alt": "profile-photo"
    },
    on: {
      "click": function($event) {
        _vm.getImageDescription.uploader !== 'admin' ?
          _vm.$router.push(
            ("/profile?selected_tab=checkins&profile_id=" + (_vm.getImageDescription.mediaSourceInformation.photoGrapherId))
          ) :
          ''
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "name-container text-xs-left"
  }, [_c('div', [_c('span', {
    on: {
      "click": function($event) {
        _vm.getImageDescription.uploader !== 'admin' ?
          _vm.$router.push(
            ("/profile?selected_tab=checkins&profile_id=" + (_vm.getImageDescription.mediaSourceInformation.photoGrapherId))
          ) :
          ''
      }
    }
  }, [_vm._v(_vm._s(_vm.getImageDescription.mediaSourceInformation.photoGrapherName))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.$modal.show('license-modal')
      }
    }
  }, [_vm._v("©")])])])])]), _vm._v(" "), _c('label', {
    staticClass: "photo-caption"
  }, [_vm._v(_vm._s(_vm.getImageDescription.caption))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-045f387e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/slideshow.vue
// module id = 825
// module chunks = 5